const translations: Record<string, string> = {
  // Header / Nav
  "site_name": "YOYBUY Spreadsheet",
  "nav_home": "Главная",
  "nav_guide": "Руководство",
  "nav_categories": "Категории",

  // Hero
  "hero_title": "YOYBUY Spreadsheet — Ваш гид по шопингу",
  "hero_subtitle": "Полное руководство по использованию YOYBUY Spreadsheet. Найдите лучшие категории товаров и начните экономить уже сегодня.",
  "btn_yoybuy_sheet": "YOYBUY Sheet",
  "btn_buy_now": "Купить сейчас",

  // Categories
  "categories_title": "Категории товаров",
  "categories_subtitle": "Выберите категорию и перейдите к покупкам",
  "category_select": "Выберите категорию",

  // Article Section
  "article_title": "Что такое YOYBUY Spreadsheet?",
  "article_read_more": "Читать полное руководство",

  // Footer
  "footer_text": "© 2026 YOYBUY Spreadsheet. Все права защищены.",
  "footer_link_home": "На главную",

  // SEO Article Page
  "article_back_home": "← Вернуться на главную",
  "article_related": "Похожие статьи",
  "article_cta": "Перейти к YOYBUY Spreadsheet",
};

export default translations;